import { CommonModule, DecimalPipe, UpperCasePipe } from '@angular/common'
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core'
import { DashboardResponse } from '@app/modules/events/models/dashboard.model'
import 'chartjs-plugin-labels'
import { DashboardService } from '../../dashboard.service'

@Component({
  selector: 'ngx-sold-products-card',
  templateUrl: './sold-products-card.component.html',
  styleUrls: ['./sold-products-card.component.scss'],
  imports: [CommonModule, DecimalPipe, UpperCasePipe]
})
export class SoldProductsCardComponent implements OnInit, AfterViewInit {
  @ViewChild('soldProducts') private chartRef: ElementRef
  @Input() dashboardData: DashboardResponse
  @Input() currencySlug: string
  online: number
  onsite: number

  constructor(private _DashboardService: DashboardService) {}
  ngOnInit(): void {
    this.calculateOnlineAndOnsite()
  }

  ngAfterViewInit(): void {
    this.renderChart()
  }

  private calculateOnlineAndOnsite(): void {
    const paymentMethod = this.dashboardData?.payment_method
    this.online = paymentMethod && paymentMethod.Online ? paymentMethod.Online.total_value : 0

    const pos = paymentMethod && paymentMethod.pos ? paymentMethod.pos.total_value : 0
    const cash = paymentMethod && paymentMethod.cash ? paymentMethod.cash.total_value : 0
    this.onsite = pos + cash
  }

  private renderChart(): void {
    const ctx = this.chartRef.nativeElement.getContext('2d')
    const labels = [`Online: ${this.online} ${this.currencySlug?.toUpperCase()}`, `Onsite: ${this.onsite} ${this.currencySlug?.toUpperCase()}`]
    const backgroundColors = ['rgba(28, 100, 242, 1)', 'rgba(253, 186, 140, 1)']
    const data = [this.online, this.onsite]
    const chartOptions = {
      rotation: 1 * Math.PI,
      circumference: 1 * Math.PI,
      cutoutPercentage: 70,
      legend: {
        display: false
      },
      plugins: {
        labels: {
          render: 'percentage',
          fontColor: '#fff',
          precision: 2,
          fontSize: 10
        }
      },
      tooltips: {
        enabled: false
      }
    }
    const options = {
      type: 'doughnut',
      labels: labels,
      datasets: [
        {
          label: '# of Sales',
          data: data,
          backgroundColor: backgroundColors,
          hoverBackgroundColor: backgroundColors,
          borderWidth: 1
        }
      ],
      chartOptions: chartOptions
    }
    this._DashboardService.renderChart(ctx, this.dashboardData, options)
  }
}
